export default "__VITE_ASSET__C0Uc2cMd__"